module.exports = __webpack_public_path__ + "static/media/tecgreen.48efb006.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tecgreen.jpg
// module id = 300
// module chunks = 0